export enum NON_EMPLOYEE_TRAVEL_PAYEE_CATEGORY { //TODO: update correct value
  INTERVIEWEE = 'Interviewee',
  SERVICE_PROVIDER = 'Service Provider',
  VOLUNTEER = 'Volunteer (UH or RCUH)',
  NON_QUALIFIED_SCHOLARSHIP_OR_FELLOWSHIP = 'Non-Qualified Scholarship/Fellowship',
  PRIZE_OR_AWARD = 'Prize or Award',
  RESEARCH_STUDY_PARTICIPANT = 'Research Study Participant',
}

export enum TRAVEL_EXPENSES_VALUE {
  AIRFARE = 'airfare',
  AUTOMOBILE = 'automobile',
  BAGGAGE = 'baggage',
  BUS = 'bus',
  CONFERENCE = 'conference',
  GAS = 'gas',
  HOTEL_TAXES = 'hotelTaxes',
  INTERNET = 'internet',
  PARKING = 'parking',
  TAXI = 'taxi',
  TELEPHONE = 'telephone',
  OTHER = 'other',
}
